import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import AddLocation from '@material-ui/icons/AddLocation';
import BarChartIcon from '@material-ui/icons/BarChart';
import ExploreIcon from '@material-ui/icons/Explore';
import MapIcon from '@material-ui/icons/Map';
import PersonIcon from '@material-ui/icons/Person';
import PhotoIcon from '@material-ui/icons/Photo';
import SecurityIcon from '@material-ui/icons/Security';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import ViewListIcon from '@material-ui/icons/ViewList';
import React from 'react';
import constants from '../../constants';

const MenuList = (props) => {
    const role = props.role;

    // Orden requerido de las opciones del CMS. Cada opción declara los roles
    // que pueden verla, de modo que el orden se mantiene independientemente
    // de los permisos de cada usuario.
    const options = [
        {
            key: 'admins',
            href: '/admins',
            label: 'Administradores',
            roles: [1],
            icon: <PersonIcon />,
        },
        {
            key: 'agentes',
            href: '/agentes',
            label: 'Agentes',
            roles: [1, 2],
            icon: <SecurityIcon />,
        },
        {
            key: 'usuarios',
            href: '/usuarios',
            label: 'Usuarios',
            roles: [1, 2],
            icon: <SupervisorAccountIcon />,
        },
        {
            key: 'incidencias',
            href: '/incidencias',
            label: 'Incidencias',
            roles: [1],
            icon: <ViewListIcon />,
        },
        {
            key: 'puntos',
            href: '/puntos',
            label: 'Puntos Seguros',
            roles: [1],
            icon: <img src={constants.urlBase + 'storage/static/images/login/gps.png'} height={24} width={24} alt="Puntos Seguros" />,
        },
        {
            key: 'monitoreo',
            href: '/mapa',
            label: 'Monitoreo',
            roles: [1, 2, 3],
            icon: <ExploreIcon />,
        },
        {
            key: 'mapa-calor',
            href: '/mapa-calor',
            label: 'Mapa Histórico',
            roles: [1, 2, 3],
            icon: <MapIcon />,
        },
        {
            key: 'estadistica',
            href: '/estadistica',
            label: 'Estadística',
            roles: [1, 2, 3],
            icon: <BarChartIcon />,
        },
        {
            key: 'publicidad',
            href: '/publicidad',
            label: 'Publicidad',
            roles: [1, 2, 4],
            icon: <PhotoIcon />,
        },
        {
            key: 'sector',
            href: '/sector',
            label: 'Sectores',
            roles: [1],
            icon: <AddLocation />,
        },
    ];

    function generate() {
        return options
            .filter((option) => option.roles.includes(role.id))
            .map((option) => (
                <ListItem key={option.key} button component="a" href={option.href}>
                    <ListItemIcon>
                        {option.icon}
                    </ListItemIcon>
                    <ListItemText primary={option.label} />
                </ListItem>
            ));
    }

    return (
        <React.Fragment>
            {generate()}
        </React.Fragment>
    )
}

export default MenuList;